module.exports = __webpack_public_path__ + "54068f3db94d7bdd8da2ea6e2e01917f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/io.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/io.svg
// module chunks = 0